<div class="col-12 widget-wrapper align-self-center">
  <div class="wallet-box">
    <!--User Details and Round timer -->
    <app-round-user-details [liveCounter]="liveCounter" [raisedInfo]="raisedInfo"></app-round-user-details>
    <!--User Details and Round timer -->

    <!-- Transaction Area -->
    <div class="swapArea" [ngClass]="{ cover: status === SwapStatus.in_progess || status === SwapStatus.confirm_pending || status === SwapStatus.approval_pending }">
      <p class="text-center mb-3 font-14 dashTitle" [ngClass]="{ shimmer: !usdRaised || usdRaised <= 0, 'mt-3': !walletAddress }">1 {{ tokenName }} = ${{ salePrice }}</p>

      <div class="tab-container gap-2">
        <button class="btn text-uppercase gap-2 w-100" [ngClass]="{ selected: swapMode === 'native' }" (click)="openSwap(true, false, false)">
          <img src="/assets/images/svg-icons/{{ modeName }}.svg" height="26" alt="" />
          <span class="fw-regular">{{ modeName }}</span>
        </button>

        <button class="btn text-uppercase gap-2 w-100" [ngClass]="{ selected: swapMode === 'usdt' }" (click)="openSwap(false, false, false)">
          <img src="/assets/images/svg-icons/usdt.svg" height="26" alt="" />
          <span class="fw-semibold">USDT</span>
        </button>

        <button class="btn text-uppercase gap-2 w-100" [ngClass]="{ selected: swapMode === 'usdc' }" (click)="openSwap(false, false, true)">
          <img src="/assets/images/svg-icons/usdc.svg" height="26" alt="" />
          <span class="fw-semibold">USDC</span>
        </button>

        <button class="btn text-uppercase gap-2 w-100" [ngClass]="{ selected: swapMode === 'card' }" (click)="openSwap(false, true, false)">
          <img src="/assets/images/svg-icons/card.svg" height="26" alt="" class="float-start" />
          <span class="fw-semibold">{{ 'widget.card' | translate }}</span>
        </button>
      </div>

      <app-swap [isNative]="isNative" [isWert]="isWert" [swapMode]="swapMode" (messageEvent)="messageEvent($event)" #swap></app-swap>

      <div class="d-flex align-items-center justify-content-center gap-2 mt-4" *ngIf="!walletAddress">
        <button class="btn btn-secondary w-100" (click)="connectModal()">
          <span>{{ 'misc.connect_wallet' | translate }}</span>
        </button>

        <button class="btn btn-secondary w-100 px-2" (click)="changeChain(modeName === 'ETH' ? 'BSC' : 'ETH')">
          <img src="/assets/images/svg-icons/{{ modeName === 'ETH' ? 'BNB' : 'ETH' }}.svg" height="18" alt="" class="me-2" />
          <span>{{ 'widget.switch_to' | translate }} {{ modeName === 'ETH' ? 'BNB' : 'ETH' }}</span>
        </button>
      </div>

      <div class="mt-3">
        <!-- <p class="font-13 text-center mb-1">
          <a *ngIf="modeName == 'ETH' && walletAddress" class="text-decoration-underline cursor-pointer text-light" href="https://widget.wert.io/default/widget/?commodity=ETH%3AEthereum" target="_blank">{{ 'widget.not_enough_eth' | translate }} </a>
        </p> -->

        <p class="font-14 text-center my-2" *ngIf="!isWert">
          <a (click)="openEthBuyWidget()" *ngIf="modeName == 'ETH' && walletAddress" class="text-decoration-underline cursor-pointer text-yellow">
            {{ 'widget.not_enough_eth' | translate }}
          </a>

          <a *ngIf="modeName == 'BNB' && walletAddress" class="text-decoration-underline cursor-pointer text-yellow" (click)="openEthBuyWidget(true)">
            {{ 'widget.not_enough_bnb' | translate }}
          </a>
        </p>

        <div class="my-2 w-100 d-flex justify-content-center align-items-center cursor-pointer" (click)="openBestWallet()" *ngIf="!walletAddress">
          <span class="d-inline-block text-white fw-regular d-flex justify-content-center font-14 text-decoration-underline"> {{ 'widget.no_wallet_click_here' | translate }}</span>
        </div>
        <!--- dont have wallet-->

        <p class="font-14 text-center fw-regular mb-0 d-flex align-items-center justify-content-center">
          <span class="me-2">{{ 'widget.powered_by' | translate }}</span>
          <a href="https://web3paymentsolutions.io" target="_blank">
            <img src="/assets/images/svg-icons/W3P_White.svg" alt="" class="poweredByIcon text-tertiary" />
          </a>
        </p>
      </div>
    </div>
    <!-- Transaction Area -->
  </div>
</div>
